<template>
  <footer class="af" dir="rtl">
    <nav class="af__nav">

      <router-link to="/" class="af__item" :class="{ 'af__item--active': isActive('/') }">
        <i class="fa fa-compass"></i>
        <span class="af__label">اكتشف</span>
      </router-link>

      <router-link to="/search" class="af__item" :class="{ 'af__item--active': isActive('/search') }">
        <i class="fa fa-search"></i>
        <span class="af__label">بحث</span>
      </router-link>

      <router-link :to="{ name: 'Points', query: { tab: 'board' } }" class="af__item" :class="{ 'af__item--active': isActive('/points') }">
        <i class="fa fa-trophy"></i>
        <span class="af__label">المتصدرون</span>
      </router-link>

      <router-link to="/AddBranch" class="af__add">
        <i class="fa fa-plus"></i>
      </router-link>

    </nav>
  </footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { api } from "@/services/api";

const route       = useRoute();
const unreadCount = ref(0);
let pollInterval  = null;

function isActive(path) { return route.path === path; }

async function fetchUnreadCount() {
  if (!localStorage.getItem("token")) { unreadCount.value = 0; return; }
  try {
    const res = await api.get("/notifications/unread-count");
    unreadCount.value = res.data?.count || 0;
  } catch {}
}

onMounted(() => {
  fetchUnreadCount();
  pollInterval = setInterval(fetchUnreadCount, 30000);
});
onUnmounted(() => { if (pollInterval) clearInterval(pollInterval); });
</script>

<style scoped lang="scss">
.af {
  background: rgba(26, 22, 18, 0.92);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-top: 1px solid var(--color-border);
  border-radius: 24px 24px 0 0;
  padding: 6px var(--space-3) max(12px, env(safe-area-inset-bottom, 12px));

  &__nav {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 52px;
    gap: 0;
  }

  // ── Tab item ──────────────────────────────────
  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
    padding: var(--space-1) var(--space-2);
    color: var(--color-text-3);
    text-decoration: none;
    transition: color var(--transition-base);
    position: relative;

    i { font-size: 1.05rem; line-height: 1; }

    &--active {
      color: var(--color-signal);

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 50%; transform: translateX(-50%);
        width: 18px; height: 3px;
        background: var(--color-signal);
        border-radius: var(--radius-full);
      }

      i { filter: drop-shadow(0 0 5px rgba(226, 182, 115, 0.45)); }
    }
  }

  &__label {
    font-size: 0.60rem;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    font-family: var(--font-display);
  }

  // ── + Add button — sage circle, inline ────────
  &__add {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    height: 52px;

    i {
      width: 40px; height: 40px;
      border-radius: 50%;
      background: var(--color-sage, #8FA37A);
      display: flex; align-items: center; justify-content: center;
      color: #1a1410;
      font-size: 1rem;
      box-shadow: 0 4px 14px -4px rgba(143, 163, 122, 0.50);
      transition: all var(--transition-base);
    }

    &:hover i {
      opacity: 0.88;
      transform: scale(1.05);
    }
  }

  // ── Bell with badge ───────────────────────────
  &__bell-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__badge {
    position: absolute;
    top: -6px; left: -8px;
    min-width: 16px; height: 16px; padding: 0 4px;
    background: var(--color-terra, #D86545);
    color: #fff;
    font-size: 0.52rem; font-weight: 800;
    font-family: var(--font-mono);
    border-radius: var(--radius-full);
    display: flex; align-items: center; justify-content: center;
    border: 1.5px solid rgba(26, 22, 18, 0.92);
    animation: badge-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
}

@keyframes badge-pop {
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}
</style>
